// BOQ editor reference data (v3_58 — materials-only BOQ, decoupled from execution packages).
// The interior designer records: Unit Area → Work Item → Material (free text) + Qty + Unit.

// Suggested scopes shown as a datalist under the free-text Work Item field. The designer may
// type anything; these are common interior-design work items to keep wording consistent.
export const WORK_ITEM_SUGGESTIONS = [
  "False Ceiling",
  "TV Unit",
  "Wardrobe",
  "Modular Kitchen",
  "Crockery Unit",
  "Wall Paneling",
  "Wall Painting",
  "Flooring",
  "Vanity / Bathroom",
  "Study / Work Table",
  "Pooja Unit",
  "Shoe Rack",
  "Partition",
  "Bar Unit",
  "Loose Furniture",
  "Curtains & Blinds",
  "Electrical & Lighting",
  "Other",
];

// Canonical units of measure for BOQ quantities. Value is stored; label is shown.
export const BOQ_UNITS = [
  { value: "Sq.ft", label: "Sq.ft" },
  { value: "Sq.m", label: "Sq.m" },
  { value: "Rft", label: "Rft (running ft)" },
  { value: "Rmt", label: "Rmt (running m)" },
  { value: "Meter", label: "Meter" },
  { value: "Nos", label: "Nos" },
  { value: "Set", label: "Set" },
  { value: "Pair", label: "Pair" },
  { value: "Dozen", label: "Dozen" },
  { value: "Litre", label: "Litre" },
  { value: "Ml", label: "Ml" },
  { value: "Kg", label: "Kg" },
  { value: "Box", label: "Box" },
  { value: "Bag", label: "Bag" },
  { value: "Sheet", label: "Sheet" },
  { value: "Roll", label: "Roll" },
  { value: "Bundle", label: "Bundle" },
  { value: "Lump sum", label: "Lump sum" },
];
